import { Link } from 'react-router-dom';
import useImageUrl from 'hooks/useImageUrl';
import routeNames from 'router/routeNames.json';
import { PriceTag } from './common/PriceTag';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { productTypes } from '../constants';
import ByUser from './common/ByUser';

export const ProductTile = ({ product, type, showFooter, link }) => {
  link = getLink(link, product, type);
  const constructImageUrl = useImageUrl();

  return (
    <div className="relative w-full">
      <PriceTag
        className="absolute top-0 right-0 z-10"
        price={product.price}
        size="small"
        showDiscount={
          type === productTypes.tees ||
          type === productTypes.kidsTees ||
          type === productTypes.prints
        }
        type={type}
      />
      <Link to={link} className="relative">
        <LazyLoadImage
          height={type !== productTypes.prints ? 306 : 366}
          width={255}
          src={constructImageUrl({
            img: product.zoom,
            width: 255,
            height: type !== productTypes.prints ? 306 : 366,
          })}
          alt={product.name}
          className="block w-full"
        />
        {type === productTypes.kidsTees && (
          <div className="block w-full bg-kids-overlay kids-tees-overlay absolute right-0 bottom-0"></div>
        )}
      </Link>

      {showFooter && (
        <div className="p-2 bg-qw-blue-500 text-white text-center">
          <h3 className="m-0">
            <Link
              to={link}
              className="block text-sm truncate uppercase text-white no-underline hover:underline"
            >
              {product.name}
            </Link>
          </h3>
          <span className="block italic text-xs truncate">
            <ByUser
              username={product.user?.username}
              to={`${routeNames.profile}/${product.user?.id}`}
            />
          </span>
        </div>
      )}
    </div>
  );
};

function getLink(link, product, type) {
  return link || `${getShopUrlSlug(type)}/${product.slug}`;
}

const getShopUrlSlug = (type) => {
  switch (type) {
    case productTypes.tees:
      return routeNames.shopTees;
    case productTypes.kidsTees:
      return routeNames.shopKids;
    case productTypes.stickers:
      return routeNames.shopStickers;
    case productTypes.prints:
      return routeNames.shopPrints;
    default:
      return routeNames.shopTees;
  }
};
